import { ALLIANCES } from '@web-platform/shared-universal-constants/src/queryParams';
import { booleanKeyValuesParamParser } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/paramParsers';
import { parseParams } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/parseParams';

import { INITIAL_STATE } from '../alliances';

import type { AlliancesFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/alliances';

export const getAlliancesFromUrl = (): AlliancesFilterState => {
  const queryParams = parseParams();
  const alliancesQueryParam = queryParams[ALLIANCES];

  if (!alliancesQueryParam) {
    return INITIAL_STATE;
  }

  const parsedAlliancesParam = booleanKeyValuesParamParser
    .deserialize(alliancesQueryParam)
    .filter(({ key }) => key.trim().length > 0);

  if (parsedAlliancesParam.length === 0) {
    return INITIAL_STATE;
  }

  return parsedAlliancesParam.reduce<AlliancesFilterState>((acc, { key, value }) => {
    acc[key] = { value };
    return acc;
  }, {});
};
